<div class="row mt-10">
  <div class="col-xs-4">
    <div [id]="identifierService.labelId('manualFollowup', 'lastFollowup')" class="sectionTitle" data-tx-key="label.gb.last_followup">
      {{ labels['label.gb.last_followup'] }}
    </div>
  </div>
  <div class="col-xs-4">
    <div [id]="identifierService.labelId('manualFollowup', 'transmitOn')" class="sectionTitle" data-tx-key="label.gb.transmit_on">
      {{ labels['label.gb.transmit_on'] }}
    </div>
  </div>
  <!-- <div class="col-xs-1"></div> -->
  <div class="col-xs-4">
    <div [id]="identifierService.labelId('manualFollowup', 'delta')" class="sectionTitle interval" data-tx-key="label.gb.delta">
      {{ labels['label.gb.delta'] }}
    </div>
  </div>
</div>
<div class="row manualDateRow smart-schedule-form" [formGroup]="manualScheduleForm">
  <div class="col-xs-4 ">
    <div [id]="identifierService.labelId('manualFollowup', 'lastTransMissionDate')" class="sectionTitle">{{lastTransMissionDate}}</div>
  </div>
  <div class="col-xs-8" formArrayName="discreteDates">
    @for (dateForm of discDates.controls; track dateForm; let i = $index) {
      <div class="row" [formGroupName]="i">
        <div class="col-xs-6">
          <merlin-date-picker [isForm]="true" [placeHolder]="translatePlaceHolder()"  id="manual_date_{{i}}" class="no-label"
            [groupName]="dateForm" controlName="date" 
            (changed)="orgValueChange($event, i)">
          </merlin-date-picker>
        </div>
        <div class="col-xs-6">
          <div class="sectionTitle fistIntrvl" [id]="identifierService.labelId('manualFollowup', 'interval_' + i)">
            {{ calculateFirstInterval(i) }}
          </div>
        </div>
      </div>
    }
  </div>

</div>